import { render, staticRenderFns } from "./ConfirmModify.vue?vue&type=template&id=4797a1c2"
import script from "./ConfirmModify.vue?vue&type=script&lang=js"
export * from "./ConfirmModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4797a1c2')) {
      api.createRecord('4797a1c2', component.options)
    } else {
      api.reload('4797a1c2', component.options)
    }
    module.hot.accept("./ConfirmModify.vue?vue&type=template&id=4797a1c2", function () {
      api.rerender('4797a1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/components/ConfirmModify.vue"
export default component.exports